module.exports = __webpack_public_path__ + "img/scholar2.9e0bba84.png";